import axios from "./axios";
import { apiUrl, eventBase, publicBase } from "./../config/crud";

const API_URL = apiUrl;
const EVENT = eventBase;
const PUBLIC = publicBase;

// Get list of speakers
export const getEventDetails = (url: string) => {
	return axios.get(`${API_URL}/${EVENT}/${PUBLIC}/g/${url}`);
};
